import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import { Breakpoint } from '@constants/common/ui.constants';

import dexfiLogo from './image/dexfiLogo.png';

const useStyles = makeStyles()((theme) => ({
  footer: {
    background: theme.secondary.s5,
    marginTop: 'auto',
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
  },
  bg: {
    position: 'absolute',
    display: 'block',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url(${dexfiLogo})`,
    pointerEvents: 'none',
    width: '100%',
    height: '100%',
    backgroundSize: '1389px 400px',
    backgroundPosition: 'center',
    zIndex: 0,

    [theme.breakpoints.down(Breakpoint.Lg)]: {
      height: '100%',
      backgroundSize: '1389px auto',
      backgroundPosition: 'center bottom',
    },

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      transform: 'rotate(270deg)',
      backgroundPosition: '0 0',
      width: '200%',
    },
  },
  box: {
    ...dFlex('space-between', 'flex-start'),
    gap: 85,
    paddingBottom: 70,
    paddingTop: 70,
    position: 'relative',
    zIndex: 1,

    [theme.breakpoints.down(Breakpoint.Lg)]: {
      display: 'grid',
      gridTemplateAreas: `
      "center center right"
      "left left left"
      `,
      paddingBottom: 30,
      paddingTop: 30,
      gap: 24,
    },

    [theme.breakpoints.down(Breakpoint.Md)]: {
      gridTemplateAreas: `
      "center"
      "right"
      "left"
      `,
      gap: 16,
    },
  },
  right: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',

    [theme.breakpoints.down(Breakpoint.Lg)]: {
      gridArea: 'right',
    },

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      paddingTop: '0',
    },
  },
  center: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: 164,

    [theme.breakpoints.down(Breakpoint.Lg)]: {
      gridArea: 'center',
    },
  },
  linksBox: {
    display: 'flex',
    gap: '85px',

    [theme.breakpoints.down(Breakpoint.Lg)]: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '60px',
    },

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      gap: '50px',
    },
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  linkItem: {
    transition: 'all 250ms ease-in-out',

    '&:hover': {
      color: theme.primary.p3,
    },
  },
  left: {
    maxWidth: 285,
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',

    [theme.breakpoints.down(Breakpoint.Lg)]: {
      gridArea: 'left',
      maxWidth: '665px',
    },

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      maxWidth: 'unset',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  copyright: {
    color: theme.secondary.s3,
    ...dFlex('initial', 'initial'),
    flexDirection: 'column',
  },
  link: {
    color: theme.secondary.s3,
    transition: 'all 250ms ease-in-out',

    '&:hover': {
      color: theme.primary.p3,
    },
  },
  termsLink: {
    a: {
      display: 'inline',
    },
  },
  footerSocials: {
    display: 'grid',
    gap: 16,
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridTemplateRows: 'repeat(2, 1fr)',

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gridTemplateRows: 'repeat(3, 1fr)',
    },
  },
  socialButton: {
    svg: {
      height: 24,
      transform: 'scale(0.833)',
      width: 24,
    },
  },
  logo: {
    height: 40,
  },
  terms: {
    ...dFlex('flex-start'),
    flexWrap: 'wrap',
    gap: 5,

    a: {
      display: 'inline',
    },
  },
}));

export default useStyles;
